import React, {useEffect, useMemo} from 'react';
import {useQuery} from "@tanstack/react-query";
import {Modal} from "../modal/modal.jsx";
import Button from "../button/button.jsx";
const imgExtensions = ['jpg', 'jpeg', 'png', 'image/jpg', 'image/jpeg', 'image/png', 'gif', 'svg', 'image/webp'];

const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const AttachShow = ({open, setOpen, remove, attachId, newOpen, newFileShow, showRemove = true, modalTitle = "Anexo", animated = true}) => {
    const getFileExtension = (file) => String(file?.type || file?.extension || "").toLowerCase();

    const {data: attachLoaded, status} = useQuery({
        queryKey: ['attachment', attachId],
        queryFn: async () => {
            const attachInfoResponse = await fetch(`${API_KEEPER}/ged/get/attach-model/${attachId}`);
            const attachInfo = await attachInfoResponse.json();
            const attachResponse = await fetch(`${API_KEEPER}/ged/attach/${attachId}`);
            const attachBlob = await attachResponse.blob();
            const type = attachInfo.extension === "pdf" ? "application/pdf" : attachInfo.extension;
            return new File([attachBlob], attachInfo.name, { type });
        },
        enabled: open && !newOpen && !!attachId,
        staleTime: Infinity,
        cacheTime: Infinity,
    });

    const attach = newOpen ? newFileShow : (open && status === "success" ? attachLoaded : null);
    const ext = getFileExtension(attach);
    const isImage = imgExtensions.includes(ext);
    const objectUrl = useMemo(() => attach && !attach.attachId ? window.URL.createObjectURL(attach) : null, [attach]);

    useEffect(() => () => {
        if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    }, [objectUrl]);

    const modalContent = () => {
        if (!attach) return;

        if (!imgExtensions.includes(ext) && ext !== "application/pdf" && ext !== "pdf") {
            return <h3 className="text-center text-[18px] font-bold">Arquivo {attach.name}</h3>;
        } else if (ext === "application/pdf" || ext === "pdf") {
            const url = attach.attachId ? API_KEEPER + "/ged/attach/print/pdf/" + attach.attachId : objectUrl;
            return (
                <h3 className="text-center text-[18px] font-bold underline">
                    <a href={url} target="_blank">Clique para visualizar o arquivo PDF</a>
                </h3>
            )
        } else {
            const url = attach.attachId ? API_KEEPER + "/ged/attach/" + attach.attachId : objectUrl;
            return <img src={url} alt={attach.name} className={"block h-[calc(100vh-190px)] max-w-full object-contain"} />
        }
    }

    return (
        <Modal open={open && !!attach} setOpen={() => setOpen(false)} title={modalTitle} backdrop="static" keyboard={false} className={isImage ? "w-fit max-w-[calc(100vw-2rem)]" : undefined} animated={animated}>

            <Modal.Body className="flex justify-center">
                {modalContent()}
            </Modal.Body>

            {
                showRemove &&
                <Modal.Footer className={"p-2"}>
                    <div className={"flex justify-end"}>
                        <Button target="danger" className={"me-2"} onClick={remove}>Remover</Button>
                    </div>
                </Modal.Footer>
            }
        </Modal>
    );
};

export default AttachShow;
